import _ from "lodash";
import React from "react";
import classes from "./ArchivedYearGroupBanner.scss";
import { useI18n } from "Hooks";
import {
  getCurrentProjectGroupDetails,
  PROJECT_TYPE_LABEL_MAP_V2,
} from "Projects/modules/ProjectModules";
import classNames from "classnames";
import { connect } from "react-redux";
import { getProjectGroupYearGroupFromCache } from "Projects/modules/ProjectGraphqlHelpers";

const ArchivedYearGroupBanner = ({
  projectGroupId,
  projectGroupType,
  academicYearId,
}) => {
  const { t } = useI18n(["project"]);
  const data = getProjectGroupYearGroupFromCache({
    id: projectGroupId,
    gradeFilters: {
      academicYearId,
    },
  });

  const projectTypeName = PROJECT_TYPE_LABEL_MAP_V2[projectGroupType]
    ? t(PROJECT_TYPE_LABEL_MAP_V2[projectGroupType])
    : _.get(data, "node.name", "");

  const bannerClasses = classNames({
    [classes.banner]: true,
    ["text-subtitle-3"]: true,
  });
  return (
    <div
      className={bannerClasses}
      data-test-id="projects-archivedYearGroupBanner"
    >
      {t("project:archived_year_group_projects_header_warning_with_label", {
        label: projectTypeName,
      })}
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  const projectGroupDetails = getCurrentProjectGroupDetails({ state });
  const { type: projectGroupType, id: projectGroupId } = projectGroupDetails;
  const academicYearId = _.get(state, "platform.academicYearSelected.id", "");

  return {
    projectGroupType,
    academicYearId,
    projectGroupId,
  };
};

export default connect(mapStateToProps)(ArchivedYearGroupBanner);
